import React, { FC, ReactNode, useState } from 'react';
import styled from 'styled-components';
import { RenderBounds, RenderBox, RenderInner } from '../../canvas/visualization/RenderHelpers';
import { Colors } from './../../../ui';
import { ReactionIcon } from './ReactionIcon';

export const ReactionIconVisual: FC<{ object: ReactionIcon, children?: ReactNode }> = ({ object, children }) => {
    return <>
        <RenderBounds object={object}>
            <RenderInner object={object}>
                <RenderEmoji emoji={object.emoji} />
            </RenderInner>
        </RenderBounds>
        {children}
    </>;
};

const RenderEmoji = React.memo(({ emoji }: { emoji: string }) => {

    const [error, setError] = useState(false);

    return <RenderBox inset="0">
        {error && <RenderError />}
        {!emoji && <RenderPlaceholder />}
        {!!emoji && <RenderImage src={`https://s.ludi.co/app/twemoji/svg/${emoji}.svg`} onError={() => setError(true)} />}
    </RenderBox>;
});

const RenderPlaceholder = () =>
    <RenderBox inset="0" display="flex" alignItems="center" justifyContent="center" background={Colors.l2} color="#fff">
        <RenderPlaceholderIcon />
    </RenderBox>;

const RenderPlaceholderIcon = () =>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 140 140" style={{ maxWidth: '75%', maxHeight: '75%' }}>
        <g fill="currentColor">
            <path d="M140 17.5A17.5 17.5 0 00122.5 0h-105A17.5 17.5 0 000 17.5v105A17.5 17.5 0 0017.5 140h105a17.5 17.5 0 0017.5-17.5zm-11.67 105a5.83 5.83 0 01-5.83 5.83h-105a5.83 5.83 0 01-5.83-5.83v-105a5.83 5.83 0 015.83-5.83h105a5.83 5.83 0 015.83 5.83z" />
            <path d="M64.17 55.42a17.5 17.5 0 1035 0 17.5 17.5 0 10-35 0zM81.67 30.63a4.38 4.38 0 004.37-4.38v-2.92a4.38 4.38 0 00-8.75 0v2.92a4.38 4.38 0 004.38 4.38zM57.95 37.88a4.38 4.38 0 106.22-6.18l-2.06-2.07a4.39 4.39 0 00-6.22 6.2zM49.58 59.8h2.92a4.38 4.38 0 000-8.76h-2.92a4.38 4.38 0 000 8.75zM105.38 72.95a4.38 4.38 0 00-6.18 6.18l2.05 2.07a4.38 4.38 0 006.2-6.19zM106.46 55.42a4.38 4.38 0 004.37 4.37h2.92a4.38 4.38 0 000-8.75h-2.92a4.38 4.38 0 00-4.37 4.38zM102.29 39.17a4.33 4.33 0 003.09-1.29l2.06-2.06a4.38 4.38 0 00-6.19-6.19L99.2 31.7a4.38 4.38 0 003.09 7.47zM92.17 93.83a26.68 26.68 0 00-8.46 1.37 1.45 1.45 0 00-.7 2.26 45.66 45.66 0 018.86 21.32.94.94 0 00.93.8h18.4a8.96 8.96 0 007.37-3.86 26.87 26.87 0 00-26.4-21.89zM46.16 84.88a40.1 40.1 0 00-25.2 8.86 1.46 1.46 0 00-.54 1.16v15.75a8.95 8.95 0 008.95 8.93h55a1.46 1.46 0 001.12-.52 1.45 1.45 0 00.3-1.2 40.3 40.3 0 00-39.63-32.98z" />
        </g>
    </svg>;

const RenderError = () =>
    <RenderBox inset="0" display="flex" alignItems="center" justifyContent="center" background={Colors.l2} color="#fff">
        Icon failed to load
    </RenderBox>;

const RenderImage = styled.img`
    display: block; 
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    max-width: initial;
    `;
